import { render, staticRenderFns } from "./CandidateMenu.html?vue&type=template&id=679a9130&scoped=true&external"
import script from "./CandidateMenu.js?vue&type=script&lang=js&external"
export * from "./CandidateMenu.js?vue&type=script&lang=js&external"
import style0 from "./CandidateMenu.scss?vue&type=style&index=0&id=679a9130&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a9130",
  null
  
)

export default component.exports